import { createSlice } from '@reduxjs/toolkit';

interface AdjustStoreProps {
    changeData:  any[],
}

export const adjustmentSliceForFB = createSlice({
    name: 'adjustment',
    initialState: {
        payload: {
            changeData: [],
        } as AdjustStoreProps
    },
    reducers: {
        saveChangeData: (state, action) => {
            state.payload.changeData = action.payload.changeData;
        },
    }
});

export const { saveChangeData } = adjustmentSliceForFB.actions;

export default adjustmentSliceForFB.reducer;